import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8","key":"svg-0"}]]

/**
 * IconIroning
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaXJvbmluZyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOSA2aDcuNDU5YTMgMyAwIDAgMSAyLjk1OSAyLjUwN2wuNTc3IDMuNDY0bC44MSA0Ljg2NWExIDEgMCAwIDEgLS45ODUgMS4xNjRoLTE2LjgyYTcgNyAwIDAgMSA3IC03aDkuOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/ironing
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconIroning = createReactComponent('outline', 'ironing', 'Ironing', __iconNode);

export default IconIroning;